import React from "react"
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from "@love-irish/ui-components/tooltip"

/**
 * Wraps a single element in a real hover/focus tooltip (not the native `title` attribute). Falls back
 * to the bare children when there is no content, so it is safe to wrap anything. The child must be a
 * single element that can take a ref (radix `asChild`).
 */
const HintTooltip: React.FC<{ content?: React.ReactNode; children: React.ReactNode }> = ({
  content,
  children,
}) => {
  if (!content) return <>{children}</>

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent className="max-w-xs text-sm">{content}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

export default HintTooltip
